// @flow

// Types
import type {
  Asset,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_ASSET_ID,
} from 'fc-model-assets'

// Libs
import { createSelector } from 'reselect'

// Selectors
import growers$ from './growers'

// Exports
export default createSelector(
  [growers$],
  function (growers: Array<Asset>): ?number {
    const first = growers[0]

    if (first) {
      return first[PROP_ASSET_ID] || null
    }

    return null
  }
)
